import Benefit1 from '../assets/svgs/benefit1.svg';
import Benefit2 from '../assets/svgs/benefit2.svg';
import Benefit3 from '../assets/svgs/benefit3.svg';
import Benefit4 from '../assets/svgs/benefit4.svg';

import BenefitBg1 from '../assets/images/benefit-bg1.png';
import BenefitBg2 from '../assets/images/benefit-bg2.png';
import BenefitBg3 from '../assets/images/benefit-bg3.png';
import BenefitBg4 from '../assets/images/benefit-bg4.png';

export default [
  {
    sn: '01',
    img: Benefit1,
    bg: BenefitBg1,
    position: 'top-10',
    title: 'Unmatched learning experiences',
    text: 'We are offering immersive learning experiences that create opportunities for you and your team to grow and develop together.'
  },
  {
    sn: '02',
    img: Benefit2,
    bg: BenefitBg2,
    position: 'top-32',
    title: 'Focus on the Future of Learning, Life and Work',
    text: 'Our learning interventions focus on skills you need for now and the future of life and work at all stages of your career'
  },
  {
    sn: '03',
    img: Benefit3,
    bg: BenefitBg3,
    position: 'top-56',
    title: 'Learn-on-the-fly',
    text: 'We are offering you a robust platform of in-house academy managers, best in class facilities, a career path tracker and one-on-one support.'
  },
  {
    sn: '04',
    img: Benefit4,
    bg: BenefitBg4,
    position: 'top-10',
    title: 'Personalised Learning',
    text: 'Whether you are looking at long-term programs or bit-sized courses, we are offering premium access to a wide variety of competency and skill-based resources, and the opportunity to access your learning anywhere.'
  }
];
